import i18next from "i18next";
import { enableWeglot } from "tmp/weglot/enableWeglot";
import { getCookieValue } from "utility";

/**
 * 【】をweglotで翻訳すると、変な翻訳になってしまうため、英語など日本語以外の言語の場合に半角括弧に変換する
 * また、～も同様の理由でスペースに変換する
 * ハッシュタグパターン（例: ハッシュタグ：#AZKiと未来へ、Official hashtag:#AZKiと未来へ）を検出し、
 * ハッシュタグ部分を<span class="no-translate">で囲む
 */
export const preprocessTextForWeglotTranslation = (text: string): string => {
  if (!enableWeglot()) {
    return text;
  }

  if (!text) {
    return text;
  }

  const lang = getCookieValue("lang");

  if (lang === "ja_JP" || i18next.language === "ja") {
    return text;
  }

  // ハッシュタグパターンを検出して no-translate で囲む
  // パターン: 「ハッシュタグ：」「hashtag:」「Official hashtag:」などの後に続く #... 部分
  const processedText = text.replace(
    /((?:ハッシュタグ|hashtag|Official\s+hashtag)[：:]\s*)(#[^\s<]+(?:\s*、\s*#[^\s<]+)*)/gi,
    '$1<span class="no-translate">$2</span>'
  );

  return processedText
    .replace(/【/g, "[")
    .replace(/】/g, "] ")
    .replace(/~/g, " ")
    .replace(/〜/g, "-")
    .replace(/＜/g, "[")
    .replace(/＞/g, "] ")
    .replace(/『/g, "[")
    .replace(/』/g, "] ")
    .replace(/「/g, "[")
    .replace(/」/g, "] ");
};
